import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router"
import { Box, Divider, IconButton, InputAdornment, Paper, TextField, Typography } from "@mui/material"
import Toggle from "../../components/Toggle"
import { useStyles } from './style'
import { ENPHASE_INSTALLER, ToggleOptions } from "./constant"
import { Form, Formik } from "formik"
import AppButton from "../../components/AppButton"
import { userSignIn, clearMessage } from '../../appRedux/actions/Auth'
import * as yup from 'yup'
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { DisplayMessage, Loader } from "../../components"
import { pushToDataLayer, USERBEHAVIOURTRACKING } from "../../utils/gaEnvironment"

const validationSchema = yup.object({
  emailId: yup.string().required('Email is required').email('Enter valid email'),
  password: yup.string().required('Password is required'),
})

const Signin = (props) => {
  const classes = useStyles()
  const [selectedToggle, setSelectedToggle] = useState(ENPHASE_INSTALLER)
  const [showPassword, setShowPassword] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (props.message) {
      setOpen(true)
      const clear = setTimeout(() => {
        props.clearMessage()
      }, 6000)
      return () => clearTimeout(clear)
    }
  }, [props.message])

  useEffect(() => {
    if (!open) {
      props.clearMessage()
    }
  }, [open])

  if (props.authUser) {
    return <Redirect to={{ pathname: '/dashboard' }} />
  }

  return (
    <div className={classes.container} >
      <Loader loading={props.loading} />
      {props.message && props.messageType && <DisplayMessage open={open} message={props.message} messageType={props.messageType} handleClose={() => setOpen(false)} />}
      <Box display="flex" flexWrap="wrap" justifyContent="space-around" alignContent="center" minHeight="90vh" height="100%">
        <Box display="flex" flexDirection="column" mb={3}>
          <Box mb={2}>
            <Typography className={classes.displayText} variant="h1">Grid Services</Typography>
          </Box>
          <Divider classes={{ root: classes.dividerColor }} />
          <Box mt={2}>
            <Typography className={classes.displayText} sx={{ fontWeight: 'bold' }} variant="h3">Intake Portal</Typography>
          </Box>
        </Box>
        <Paper className={classes.signin}>
          <div className={classes.root}>
            Sign In
            </div>
          <Box m={2}>
            <Toggle
              list={ToggleOptions}
              selected={selectedToggle}
              onChange={(id) => {
                setSelectedToggle(id)
              }}
            />
          </Box>
          <Box className={classes.helperText} m={2}>
            Use your Enlighten Manager credentials to submit applications on behalf of homeowners
            </Box>
          <Formik
            initialValues={{
              emailId: '',
              password: '',
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              pushToDataLayer({ event: USERBEHAVIOURTRACKING })
              props.userSignIn(values)
              //props.history.push('/dashboard')
            }}
          >
            {(formik) => (
              <Form>
                <Box m={2}>
                  <TextField
                    fullWidth
                    label="Email Id"
                    name="emailId"
                    variant="standard"
                    id="emailId"
                    onChange={formik.handleChange}
                    value={formik.values.emailId}
                    error={formik.touched.emailId && Boolean(formik.errors.emailId)}
                    helperText={formik.touched.emailId && formik.errors.emailId}
                  />
                </Box>
                <Box m={2}>
                  <TextField
                    fullWidth
                    type={showPassword ? 'text' : 'password'}
                    label="Password"
                    name="password"
                    variant="standard"
                    id="password"
                    onChange={formik.handleChange}
                    value={formik.values.password}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((show) => !show)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>,
                    }}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                  />
                </Box>
                <Box display="flex" justifyContent="space-between" m={2}>
                  <a className={classes.linkText} href="https://enlighten.enphaseenergy.com/manager/registration" target="_blank" rel="noopener noreferrer">
                    Sign Up
                  </a>
                  <a className={classes.linkText} href="https://enlighten.enphaseenergy.com/forgot_password" target="_blank" rel="noopener noreferrer">
                    Forgot Password
                  </a>
                </Box>
                <Box display="flex" justifyContent="center" mt={5} mb={2}>
                  <AppButton type="submit" text="Sign in" />
                </Box>
              </Form>
            )}
          </Formik>
        </Paper>
      </Box>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, message, messageType, loading } = auth
  return { authUser, message, messageType, loading }
}

const mapDispatchToProps = dispatch => ({
  userSignIn: payload => dispatch(userSignIn(payload)),
  clearMessage: () => dispatch(clearMessage())
})

export default connect(mapStateToProps, mapDispatchToProps)(Signin)